module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/WechatIMG146.495f0b7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/WechatIMG146.jpeg
// module id = AP7i
// module chunks = 3